import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { APP_PRICING_URL } from "@/lib/appUrls";

export const HeroContent = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, ease: "easeOut" }}
      className="max-w-3xl mx-auto text-center space-y-7"
    >
      <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.08]">
        Your job site photos
        <span className="block text-blue-200">are your proof.</span>
      </h1>
      <p className="text-lg sm:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto">
        When a dispute, back charge, or insurance claim comes up, you need the right
        photo fast. Property Vue keeps every job site photo in one place, timestamped
        and searchable. $20 a month for everything.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-1">
        <a
          href={APP_PRICING_URL}
          className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-primary font-semibold rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-white/20 hover:scale-[1.02]"
        >
          Get started
          <ChevronRight size={20} />
        </a>
        <div className="text-center sm:text-left">
          <p className="text-2xl font-bold text-white">$20/month</p>
          <p className="text-sm text-gray-400">Everything included</p>
        </div>
      </div>
    </motion.div>
  );
};
